export default "__VITE_ASSET__cb323af1__$_?nuxt_component=async__"